import { Controller, UseFormRegister, FieldErrors, Control } from "react-hook-form";
import InputMask from "react-input-mask";
import { forwardRef } from "react";

// ----------------------------
// --- INTERFACE DE CLIENTE ---
// ----------------------------
export interface ClienteData {
  id?: string;
  cpf_cnpj: string;
  nome: string;
  nome_preferencial?: string;
  email?: string;
  email_secundario?: string;
  telefone?: string;
  nascimento_abertura?: string;
  tipo?: string;
  rg?: string;
  tipo_pessoa?: string;
  cliente?: string;
  sexo?: string;
  data_inclusao?: string | null;
  situacao?: string;
  tipo_documento?: string;
  data_expedicao?: string | null;
  orgao_expedidor?: string;
  naturalidade?: string;
  cnh?: string;
  venc_cnh?: string | null;
  estado_civil?: string;
  titular_conta_cartao?: string;
  tipo_conta?: string;
  cpf_titular?: string;
  banco?: string;
  agencia?: string;
  digito?: string | null;
  conta_corrente?: string;
  digito1?: string | null;
  codigo_externo?: string;
  cartao_credito?: string;
  mes_ano_venci?: string;
  bandeira_cartao?: string;
  endereco?: string;
  bairro?: string;
  cep?: string;
  cidade?: string;
  estado?: string;
  digisacid?: string | null;
  agendar_aniversario?: string | null;
  data_posvenda?: string | null;
  createdAt?: string;
}

// ----------------------------
// --- COMPONENTES DE LAYOUT ---
// ----------------------------
export function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-6">
      <h2 className="text-sm font-semibold mb-2">{title}</h2>
      {children}
    </section>
  );
}

export function TwoColumnGrid({ children }: { children: React.ReactNode }) {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-2">{children}</div>;
}

// ----------------------------
// --- INPUT CONTROLADO ---
// ----------------------------
interface FormFieldProps {
  name: keyof ClienteData;
  label: string;
  type?: "text" | "email" | "date" | "masked";
  mask?: string;
  required?: boolean;
  control: Control<ClienteData>;
  errors: FieldErrors<ClienteData>;
}

// forwardRef não é mais necessário, Controller já gerencia ref
export function FormField({ name, label, type = "text", mask, required, control, errors }: FormFieldProps) {
  return (
    <div>
      <Controller
        name={name}
        control={control}
        rules={required ? { required: `${label} é obrigatório` } : {}}
        defaultValue=""
        render={({ field }) => {
          // Valor seguro para evitar null/undefined
          const value = field.value ?? "";

          if (type === "masked" && mask) {
            return (
              <InputMask {...field} value={value} mask={mask} disabled={false}>
                {(inputProps) => (
                  <input
                    {...inputProps}
                    placeholder={label}
                    className="p-2 border rounded w-full focus:ring focus:ring-blue-200"
                  />
                )}
              </InputMask>
            );
          }

          return (
            <input
              {...field}
              value={value}
              type={type}
              placeholder={label}
              className="p-2 border rounded w-full focus:ring focus:ring-blue-200"
            />
          );
        }}
      />
      {errors[name] && <span className="text-red-500 text-xs">{errors[name]?.message}</span>}
    </div>
  );
}
